import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {SaveErrorDetailProps} from '../../email-maker-save-error-popup.types';

/** Fallback detail used for any error code that has no registered custom detail component; renders the backend message. */
export function DefaultSaveErrorDetail({saveError}: SaveErrorDetailProps): ReactElement {
  return <Text val={saveError.message ?? ''} size={TextSize.MD} className="ct-neutral-primary" />;
}
